import React from 'react';
import { FaArrowDown, FaCheckCircle, FaTimesCircle, FaYenSign } from 'react-icons/fa';
import { motion } from 'framer-motion';

const NewHero = () => {
  // Tanggal webinar (28 Mei 2025 - sesuaikan tanggal sesuai kebutuhan)
  const webinarDate = "28 Mei 2025";
  
  return (
    <section id="hero" className="py-16 md:py-20 bg-gradient-to-b from-darkBlue via-darkerBlue to-darkBlue text-white relative overflow-hidden">
      {/* Japanese Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 right-20 text-primary text-[200px] font-bold">生</div>
        <div className="absolute bottom-20 left-20 text-primary text-[200px] font-bold">甲</div>
        <div className="absolute top-1/2 right-1/3 text-primary text-[150px] font-bold">斐</div>
      </div>
      
      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        
        {/* Japanese Philosophy Badge */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/30 rounded-full px-6 py-2">
            <FaYenSign className="text-primary" />
            <span className="text-primary font-semibold">Teknik Scalping Gold 'Ikigai' ala Trader Jepang</span>
            <span className="text-xs text-japanese">生き甲斐</span>
          </div>
        </motion.div>
        
        {/* Headline Section */}
        <div className="text-center mb-16 md:mb-20">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="mb-8"
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-2">
              <span className="text-primary block text-5xl md:text-6xl lg:text-7xl mb-4 tracking-wider">NEWS HACK</span>
              <span className="text-textGray text-2xl md:text-3xl lg:text-4xl font-light">Master Trading Saat News</span>
            </h1>
          </motion.div>
          
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 leading-tight">
            <span className="text-gray-200">2025: Peluang Besar di Pasar Forex saat</span>
            <br/>
            <span className="text-primary">Rilis Berita Ekonomi Dunia</span>
          </h2>
          
          <p className="text-lg md:text-xl mb-6 max-w-2xl mx-auto leading-relaxed">
            Kebanyakan trader <span className="text-red-500 font-bold">RUGI BESAR</span> saat market bergejolak karena berita penting...
            <br/>
            <span className="text-primary font-bold">Padahal justru di situlah peluang profit 100-200 pips dalam hitungan menit!</span>
          </p>
          
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-xl md:text-2xl font-bold mb-8"
          >
            <p className="mb-4">Jawabannya hanya ada 1:</p>
            <div className="bg-gradient-to-r from-primaryDark via-primary to-primaryLight text-transparent bg-clip-text text-3xl md:text-4xl font-extrabold">
              STRATEGI NEWS HACK
            </div>
            <p className="text-sm md:text-base text-primary mt-2">Filosofi Trading Ikigai (生き甲斐) - "Alasan untuk Hidup"</p>
          </motion.div>
          
          <p className="text-base md:text-lg mb-8">
            Kami bongkar rahasianya di webinar eksklusif {webinarDate}...
          </p>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="flex justify-center"
          >
            <a 
              href="/checkout" 
              className="group bg-gradient-to-r from-primaryDark to-primary hover:from-primary hover:to-primaryLight text-darkBlue font-bold py-4 px-8 rounded-full text-lg md:text-xl flex items-center gap-3 transform hover:scale-105 transition-all duration-300 shadow-2xl"
            >
              <span>Daftar Webinar Eksklusif</span>
              <FaArrowDown className="animate-bounce group-hover:animate-none" />
            </a>
          </motion.div>
        </div>
        
        {/* Chart Result Section */}
        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <div className="bg-gradient-to-br from-darkGray/50 to-darkGray/30 p-6 md:p-8 rounded-2xl backdrop-blur-sm border border-primary/20 shadow-2xl">
            <img 
              src="/images/chart-results.jpg" 
              alt="Hasil Trading saat News dengan News Hack" 
              className="w-full h-auto rounded-lg shadow-xl mb-5"
            />
            
            <div className="text-center">
              <div className="inline-block bg-primary/20 border border-primary/40 rounded-lg px-4 py-2 mb-4">
                <span className="text-primary font-bold">Hasil Real Trading</span>
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-4 text-primary">
                Profit 187 Pips dalam 15 Menit!
              </h3>
              <p className="text-base md:text-lg mb-3 text-textGray">
                Hasil trading dengan strategi News Hack saat rilis NFP Februari 2023
              </p>
              
              <p className="text-base md:text-lg mb-3">
                Pasar Forex akan sangat volatil saat rilis berita ekonomi penting seperti NFP, CPI, atau keputusan suku bunga bank sentral.
                <span className="text-primary font-bold"> Dalam hitungan menit, market bisa bergerak 100-200 pips!</span>
              </p>
              
              <p className="text-base md:text-lg">
                Di saat sebagian besar trader panik dan rugi, justru momen inilah yang bisa menghasilkan profit besar jika Anda tahu tekniknya...
              </p>
            </div>
          </div>
        </motion.div>
        
        {/* Problem Section */}
        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <div className="bg-gradient-to-br from-darkGray/30 to-transparent p-6 md:p-8 rounded-2xl backdrop-blur-sm border border-red-500/20">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-center">
              <span className="text-red-500">⚠️ AWAS!</span> Kesalahan Fatal 95% Trader Saat News
            </h3>
            
            <div className="space-y-3 mb-5">
              <div className="flex items-start gap-2">
                <FaTimesCircle className="text-red-500 text-base mt-1 flex-shrink-0" />
                <p className="text-sm md:text-base">Trading semua berita tanpa tahu berita mana yang paling berpengaruh</p>
              </div>
              <div className="flex items-start gap-2">
                <FaTimesCircle className="text-red-500 text-base mt-1 flex-shrink-0" />
                <p className="text-sm md:text-base">Masuk market terlalu awal sebelum berita dirilis, terkena slippage besar</p>
              </div>
              <div className="flex items-start gap-2">
                <FaTimesCircle className="text-red-500 text-base mt-1 flex-shrink-0" />
                <p className="text-sm md:text-base">Tidak punya strategi entry dan exit yang jelas, trading berdasarkan feeling</p>
              </div>
              <div className="flex items-start gap-2">
                <FaTimesCircle className="text-red-500 text-base mt-1 flex-shrink-0" />
                <p className="text-sm md:text-base">Tanpa money management yang tepat, beresiko kena Margin Call</p>
              </div>
              <div className="flex items-start gap-2">
                <FaTimesCircle className="text-red-500 text-base mt-1 flex-shrink-0" />
                <p className="text-sm md:text-base">Masuk posisi trading berdasarkan prediksi arah market yang sering meleset</p>
              </div>
              <div className="flex items-start gap-2">
                <FaTimesCircle className="text-red-500 text-base mt-1 flex-shrink-0" />
                <p className="text-sm md:text-base">Terburu-buru close posisi karena panik saat market bergejolak</p>
              </div>
            </div>
            
            <div className="border-t border-gray-700 pt-5 text-center">
              <p className="text-base md:text-lg mb-4">
                Daripada pakai cara-cara di atas yang berisiko tinggi, lebih baik pelajari strategi News Hack yang sudah terbukti menghasilkan profit konsisten saat trading berita!
              </p>
              
              <div className="text-base md:text-lg font-semibold mb-3 text-primary">
                Cara ini tidak banyak orang yang tahu...
              </div>
              
              <p className="text-sm md:text-base mb-3">
                Anda tidak bisa mendapatkan ilmu ini di Google, YouTube, atau dari ChatGPT.
              </p>
              
              <motion.div 
                initial={{ scale: 0.9 }}
                animate={{ scale: [0.9, 1.05, 1] }}
                transition={{ duration: 0.5 }}
                className="text-xl md:text-2xl font-bold bg-gradient-to-r from-primary to-primaryLight text-transparent bg-clip-text"
              >
                Kami bongkar rahasianya di webinar eksklusif {webinarDate}!
              </motion.div>
            </div>
          </div>
        </motion.div>
        
        {/* Flyer Section */}
        <div className="flex justify-center mb-12">
          <div className="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg">
            <img 
              src="/images/flyer-news-hack.jpg" 
              alt="News Hack Webinar Flyer" 
              className="w-full h-auto rounded-lg shadow-xl hover:scale-102 transition-transform duration-300"
            />
          </div>
        </div>
        
        {/* Benefits Section */}
        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <div className="bg-gradient-to-br from-primaryLight/10 to-primary/5 p-8 md:p-10 rounded-2xl backdrop-blur-sm border border-primary/30 shadow-2xl">
            <div className="text-center mb-8">
              <h3 className="text-3xl md:text-4xl font-bold mb-3">
                <span className="text-primary">Webinar Eksklusif NEWS HACK</span>
              </h3>
              <p className="text-lg text-primary">Filosofi Trading Ikigai (生き甲斐) × Scalping Gold</p>
            </div>
            
            <div className="space-y-3 mb-6">
              <div className="flex items-start gap-2 bg-darkGray/30 p-3 rounded-lg hover:bg-darkGray/50 transition-colors">
                <FaCheckCircle className="text-primary text-lg mt-1 flex-shrink-0" />
                <div>
                  <p className="text-base md:text-lg font-semibold mb-1">3 Berita Ekonomi "Golden Hour" 🇯🇵</p>
                  <p className="text-sm md:text-base text-textGray">Timing presisi ala trader Jepang untuk menangkap momentum terbaik</p>
                </div>
              </div>
              <div className="flex items-start gap-2 bg-darkGray/30 p-3 rounded-lg hover:bg-darkGray/50 transition-colors">
                <FaCheckCircle className="text-primary text-lg mt-1 flex-shrink-0" />
                <div>
                  <p className="text-base md:text-lg font-semibold mb-1">Teknik "Ichimoku News Prediction"</p>
                  <p className="text-sm md:text-base text-textGray">Rahasia analisa pre-news dengan akurasi 85%+</p>
                </div>
              </div>
              <div className="flex items-start gap-2 bg-darkGray/30 p-3 rounded-lg hover:bg-darkGray/50 transition-colors">
                <FaCheckCircle className="text-primary text-lg mt-1 flex-shrink-0" />
                <div>
                  <p className="text-base md:text-lg font-semibold mb-1">"Zen Money Management"</p>
                  <p className="text-sm md:text-base text-textGray">Filosofi keseimbangan risk-reward optimal untuk news trading</p>
                </div>
              </div>
              <div className="flex items-start gap-2 bg-darkGray/30 p-3 rounded-lg hover:bg-darkGray/50 transition-colors">
                <FaCheckCircle className="text-primary text-lg mt-1 flex-shrink-0" />
                <div>
                  <p className="text-base md:text-lg font-semibold mb-1">"Samurai Entry" Strategy</p>
                  <p className="text-sm md:text-base text-textGray">Entry & exit presisi menghasilkan 100-200 pips dalam hitungan menit</p>
                </div>
              </div>
              <div className="flex items-start gap-2 bg-darkGray/30 p-3 rounded-lg hover:bg-darkGray/50 transition-colors">
                <FaCheckCircle className="text-primary text-lg mt-1 flex-shrink-0" />
                <div>
                  <p className="text-base md:text-lg font-semibold mb-1">"Ninja Defense" Protection</p>
                  <p className="text-sm md:text-base text-textGray">Teknik menghindari slippage & MC saat volatilitas ekstrem</p>
                </div>
              </div>
              <div className="flex items-start gap-2 bg-darkGray/30 p-3 rounded-lg hover:bg-darkGray/50 transition-colors">
                <FaCheckCircle className="text-primary text-lg mt-1 flex-shrink-0" />
                <div>
                  <p className="text-base md:text-lg font-semibold mb-1">Template "Shogun Trading Plan"</p>
                  <p className="text-sm md:text-base text-textGray">Blueprint siap pakai untuk NFP, CPI, FOMC & lainnya</p>
                </div>
              </div>
              <div className="flex items-start gap-2 bg-darkGray/30 p-3 rounded-lg hover:bg-darkGray/50 transition-colors">
                <FaCheckCircle className="text-primary text-lg mt-1 flex-shrink-0" />
                <div>
                  <p className="text-base md:text-lg font-semibold mb-1">Akses "Golden Calendar" Premium</p>
                  <p className="text-sm md:text-base text-textGray">Kalender berita eksklusif dengan analisa dampak real-time</p>
                </div>
              </div>
            </div>
            
            <div className="text-center mt-8">
              <motion.a 
                href="/checkout" 
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
                className="bg-gradient-to-r from-primaryDark to-primary hover:from-primary hover:to-primaryLight text-darkBlue font-bold py-4 px-10 rounded-full text-lg md:text-xl inline-block shadow-2xl relative overflow-hidden group"
              >
                <span className="relative z-10">IKUT WEBINAR EKSKLUSIF</span>
                <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity"></div>
              </motion.a>
              <p className="text-base md:text-lg mt-4 text-primary font-semibold">
                {webinarDate} • 19:30 WIB • Via Zoom
              </p>
              <p className="text-sm text-textGray mt-2">
                Terbatas untuk 100 peserta pertama
              </p>
            </div>
          </div>
        </motion.div>
        
      </div>
    </section>
  );
};

export default NewHero;